// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { getDatabase, ref, onValue } from 'firebase/database';
import { API_URL } from '../configs';
import useAuthStore from './auth';

const useNotificationsStore = create((set) => ({
  notifications: {},

  reset: () => set({ notifications: {} }),

  attachNotificationsListener: () => {
    const { user } = useAuthStore.getState();
    const { clientId } = user;
    if (!clientId) return;
    const node = ref(getDatabase(), `clientNotifications/${clientId}`);
    onValue(node, (snapshot) => {
      set({ notifications: snapshot.val() || {} });
    });
  },

  deleteNotification: async (notificationId) => {
    try {
      await axios.delete(`${API_URL}/api/notifications/${notificationId}`);
    } catch (err) {
      console.error(err);
    }
  },
}));

export default useNotificationsStore;
